import {
  saveListRepositorySdgs,
  saveCountRepositorySdgs,
} from "../Infrastructure/RepositorySdgs.store";
import { getRepositorySdgsLogic } from "./RepositorySdgs.logic";

export async function getRepositorySdgs(params) {
  const { count, resources: repositorySdgs } = await getRepositorySdgsLogic(
    params
  );

  saveListRepositorySdgs(repositorySdgs);
  saveCountRepositorySdgs(count);
}
